﻿import { events } from "@grindex-common/helpers/events";
import TabNames from "@grindex-client/components/Tabs/TabNames.class";
import asyncModule from "@grindex-client/components/Module/asyncModule";
import { apiConfig } from "@grindex-common/helpers/apiConfig";
import DocumentsApiBase from "./DocumentsApi.class";

(function listenForEvent() {
	asyncModule("nativeSubmittals", events.tabLoadedEvent(new TabNames().product.submittals), init);
})();

function init($module) {
	const salesCode = $module.dataset.apiQuery;
	const language = apiConfig.apiLanguage;
	const apiUrl = `/api/nativedocuments/getsubmittals/?productId=${salesCode}&language=${language}`;
	const documentLoader = new DocumentsApiBase($module, apiUrl);

	documentLoader.run();
}

export default {
	view: "nativeSubmittals",
	init,
};
